var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"stage-controller"},[_c('keep-alive',[_c('program',_vm._b({attrs:{"dataHelper":_vm.dataHelper,"pastSessions":_vm.pastSessions},on:{"play":_vm.openSession}},'program',_vm.$props,false))],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }